import { styled } from "~/common/mui";

export const PreviewTableRoot = styled("div")(({ theme }) => ({
  "& .scha__bulk-preview__table__header": {
    fontWeight: "bold",
  },
  "& .scha__bulk-preview__table__left-side": {
    width: "5%",
  },
  "& .scha__bulk-preview__table__right-side": {
    width: "95%",
    "& .scha__qty-input": { margin: 0 },
  },
  "& .scha__bulk-preview__table__right-side__col-container": {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    "& > *:nth-child(1)": { width: "27.37%" },
    "& > *:nth-child(2)": { width: "22.11%" },
    "& > *:nth-child(3)": { width: "24.21%" },
    "& > *:nth-child(4)": { width: "26.32%" },
    [theme.breakpoints.up("tablet")]: {
      flexDirection: "row",
      gap: 0,
    },
  },
  "&.scha__bulk-preview__table--priceRef .scha__bulk-preview__table__left-side": {
    width: "10%",
  },
  "&.scha__bulk-preview__table--priceRef .scha__bulk-preview__table__right-side": {
    width: "90%",
  },
  "&.scha__bulk-preview__table--priceRef .scha__bulk-preview__table__right-side__col-container": {
    "& > *:nth-child(1)": { width: "25%" },
    "& > *:nth-child(2)": { width: "19.44%" },
    "& > *:nth-child(3)": { width: "19.44%" },
    "& > *:nth-child(4)": { width: "25%" },
    "& > *:nth-child(5)": { width: "11.11%" },
  },
  "&.scha__bulk-preview__table--priceRef.scha__bulk-preview__table--targetPrice .scha__bulk-preview__table__right-side__col-container":
    {
      "& > *:nth-child(1)": { width: "22.11%" },
      "& > *:nth-child(2)": { width: "18.95%" },
      "& > *:nth-child(3)": { width: "21.05%" },
      "& > *:nth-child(4)": { width: "22.11%" },
      "& > *:nth-child(5)": { width: "15.79%" },
    },
  ".scha__bulk-preview__table__header": {
    background: theme.palette.surfaceContainerLowest.main,
    height: theme.spacing(5),
    display: "none",
    alignItems: "center",
    borderBottom: `3px solid ${theme.palette.divider}`,
    "&.text-color": { color: theme.palette.text.primary },
    "& .icon-size": { fontSize: theme.spacing(2.5) },
    [theme.breakpoints.up("tablet")]: {
      display: "flex",
    },
  },
  ".scha__bulk-preview__table__body": {
    overflow: "auto",
    maxHeight: "60vh",
  },
  ".scha__bulk-preview__table__row": {
    display: "flex",
    padding: `${theme.spacing(3.75)} 0`,
    width: "100%",
    "&:not(:last-child)": {
      borderBottom: `1px solid ${theme.palette.divider}`,
    },
  },
  ".scha__bulk-preview__table__right-side__error-messages": {
    display: "flex",
    flexDirection: "column",
    marginTop: theme.spacing(1),
    gap: theme.spacing(1),
  },
  ".scha__bulk-preview__table__right-side__col-container > div": {
    padding: `0 ${theme.spacing(1)} !important`,
    [theme.breakpoints.up("tablet")]: {
      "&:first-child": { paddingLeft: `${theme.spacing(2)} !important` },
      "&:last-child": { paddingRight: `${theme.spacing(2)} !important` },
    },
  },
  ".scha__bulk-preview__table__header > div": {
    padding: `0 ${theme.spacing(1)} !important`,
    "&:first-child": { paddingLeft: `${theme.spacing(2)} !important` },
    "&:last-child": { paddingRight: `${theme.spacing(2)} !important` },
  },
  "&.scha__bulk-preview__table--priceRef.scha__bulk-preview__table--targetPrice .scha__bulk-preview__table__right-side__col-container .price_reference":
    {
      minWidth: "232px",
      maxWidth: "232px",
    },
  "&.scha__bulk-preview__table--priceRef .scha__bulk-preview__table__right-side__col-container .price_reference": {
    minWidth: "275px",
    maxWidth: "275px",
  },
  ".scha__bulk-preview__table__comment-box": {
    width: "73.68%",
  },
  ".bulk_preview_tp": {
    width: "20%",
  },
}));
